import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon, PlayIcon } from 'lucide-react';
import { PressStrip } from '../components/PressStrip';
import { ConcernFinder } from '../components/ConcernFinder';
import { Reveal } from '../components/Reveal';
import { articles, episodes, founder, philosophy, salon, testimonials } from '../data/content';
import { treatments, bindweefsel } from '../data/treatments';
import { brands, products } from '../data/products';
import { useStore } from '../contexts/StoreContext';
const marquee = ['Bindweefselmassage', 'Hormonale huid', 'Anti-ageing', 'Pigmentatie', '100% vegan', 'Amsterdam-Oost'];
export function Home() {
  const {
    openBooking
  } = useStore();
  const signature = treatments.filter(t => t.signature).slice(0, 3);
  const shopHighlights = products.filter(p => p.salonFavourite || p.bestseller).slice(0, 3);
  return <>
      {/* Hero */}
      <section className="bg-sand" data-id="element-321" data-mp="3ovasyduw0z5r">
        <div className="mx-auto grid max-w-content items-end gap-10 px-6 pb-12 pt-10 lg:grid-cols-12 lg:gap-12 lg:px-10 lg:pb-16 lg:pt-14" data-id="element-322" data-mp="30wroce8elteh">
          <div className="lg:col-span-6" data-id="element-323" data-mp="2vyq8e269ya78">
            <p className="rule-label text-[11px] uppercase tracking-widest text-clay" data-id="element-324" data-mp="2vvvn68ffslcr">
              Huidstudio &amp; webshop · {salon.city}
            </p>
            <h1 className="mt-8 font-display text-[3rem] font-light leading-[0.95] text-ink sm:text-[4.25rem] lg:text-[5rem]" data-id="element-325" data-mp="2mvyvrz1nx8e0">
              Transformeer
              <br data-id="element-326" data-mp="2d777c0vt967u" />
              je huid,
              <br data-id="element-327" data-mp="2d65qtgw0zriq" />
              <span className="italic text-clay" data-id="element-328" data-mp="2d5m83xyjwz3n">transformeer je leven.</span>
            </h1>
            <p className="mt-8 max-w-lg text-[17px] leading-relaxed text-muted" data-id="element-329" data-mp="288ngpn69v695">
              Holistische huidverbetering bij hormonale disbalans, pigmentatie en veroudering.
              Bindweefselmassage, cosmeceutical emerginC en eerlijk advies — nooit één recept voor
              iedereen.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-330" data-mp="1uafqdy3qr36y">
              <button type="button" onClick={() => openBooking()} className="group inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-331" data-mp="1kjxo90ntkt6w">
                Boek een behandeling
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} data-id="element-332" data-mp="1flw7imdv95yl" />
              </button>
              <Link to="/webshop" className="rounded-full border border-ink/20 px-7 py-4 text-sm text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-333" data-mp="28c4gbnmiie0i">
                Shop skincare
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-334" data-mp="2m89jr1j6t427">
            <div className="relative lg:pl-8" data-id="element-335" data-mp="2r12mxkz0c4c6">
              <img src={founder.atWork} alt={`${founder.name} geeft een gezichtsbehandeling in de salon`} className="arch aspect-[4/5] w-full object-cover" data-id="element-336" data-mp="2r2vvx6x3f0nc" />
              <figure className="mt-4 flex items-center gap-4 bg-shell p-4 ring-1 ring-line sm:absolute sm:-left-2 sm:bottom-6 sm:mt-0 sm:max-w-[17rem]" data-id="element-337" data-mp="oe4cgljkcbzl">
                <img src={founder.portrait} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover object-top" data-id="element-338" data-mp="kd2cg2htnvwk" />
                <figcaption data-id="element-339" data-mp="3nukiq5hy4uuv">
                  <p className="font-display text-base leading-tight text-ink" data-id="element-340" data-mp="3nvc4yppnlg8h">{founder.name}</p>
                  <p className="mt-1 text-[12px] leading-snug text-muted" data-id="element-341" data-mp="5ljnhf6zir12">
                    {founder.role} · 20+ jaar
                  </p>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>

        <div className="overflow-hidden border-y border-line py-3" data-id="element-342" data-mp="1c4855xv7qrbt">
          <ul aria-hidden="true" className="flex w-max animate-marquee items-center gap-8 pr-8 motion-reduce:animate-none" data-id="element-343" data-mp="1c62qveeb6ngy">
            {[...marquee, ...marquee].map((word, i) => <li key={`${word}-${i}`} className="flex items-center gap-8 whitespace-nowrap font-display text-[15px] italic text-muted/70" data-id="element-344" data-mp="2hcccasmm8o7w" data-mpi={i}>
                {word}
                <span className="h-1 w-1 rounded-full bg-clay/40" data-id="element-345" data-mp="2qdainhkj17tn" />
              </li>)}
          </ul>
        </div>
      </section>

      <PressStrip tone="sand" data-id="element-346" data-mp="2va9bzxwd9aqs" />

      <ConcernFinder data-id="element-347" data-mp="302kbizn72uit" />

      {/* Signature treatments */}
      <section className="bg-sand py-20 lg:py-28" data-id="element-348" data-mp="3032gqlru4j2v">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-349" data-mp="351domqykkjig">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-350" data-mp="350vo3i4vjj4q">
            <div className="max-w-xl" data-id="element-351" data-mp="3a21db5zbso9i">
              <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-352" data-mp="39yx41u7072bz">Signature</p>
              <h2 className="mt-4 font-display text-4xl font-light leading-[1.1] text-ink sm:text-[2.9rem]" data-id="element-353" data-mp="3e08ycd0tobqi">
                Behandelingen waar men voor terugkomt
              </h2>
            </div>
            <Link to="/behandelingen" className="text-sm text-ink underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay hover:underline" data-id="element-354" data-mp="yfhgvn3jr41j">
              Alle behandelingen &amp; prijzen
            </Link>
          </div>

          <div className="mt-12 grid gap-x-8 gap-y-12 md:grid-cols-3" data-id="element-355" data-mp="1m261whnurcmd">
            {signature.map((t, i) => <Reveal key={t.slug} delay={i * 0.05} className="h-full" data-id="element-356" data-mp="1h5z4jd9iv9g1" data-mpi={i}>
                <article className="flex h-full flex-col border-t border-ink/70 pt-6" data-id="element-357" data-mp="1cbuuum8vgnb9">
                  <p className="font-display text-[13px] italic text-clay" data-id="element-358" data-mp="17d1feoa0ym8g">{t.category}</p>
                  <h3 className="mt-3 font-display text-[1.75rem] font-light leading-tight text-ink" data-id="element-359" data-mp="24uidzw4b5s9p">
                    {t.name}
                  </h3>
                  <p className="mt-2 text-[13px] text-muted" data-id="element-360" data-mp="200xajojy4634">{t.tagline}</p>
                  <p className="mt-5 text-[15px] leading-relaxed text-muted" data-id="element-361" data-mp="3ubdwzn157zzb">
                    {t.description.split('. ').slice(0, 2).join('. ')}.
                  </p>
                  <div className="mt-auto pt-7" data-id="element-362" data-mp="3kjq21c5do0t3">
                    <p className="flex items-baseline justify-between border-t border-line pt-4 text-[13px] text-muted" data-id="element-363" data-mp="3kiydgla773cb">
                      <span data-id="element-364" data-mp="3amv5gyso0ahg">{t.duration}</span>
                      <span className="font-display text-lg text-ink" data-id="element-365" data-mp="3al1wvdyhrg6t">{t.price}</span>
                    </p>
                    {t.kuur && <p className="mt-1.5 text-[12px] text-muted" data-id="element-366" data-mp="3fjlkrjwnb21t">Kuur · {t.kuur}</p>}
                    <button type="button" onClick={() => openBooking(t.name)} className="mt-5 w-full rounded-full border border-ink/20 py-3 text-[13px] text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-shell" data-id="element-367" data-mp="31nrhbgen54w3">
                      Boeken
                    </button>
                  </div>
                </article>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Bindweefsel band */}
      <section className="bg-ink py-20 text-shell lg:py-24" data-id="element-368" data-mp="1npn80447clyh">
        <div className="mx-auto grid max-w-content gap-10 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-369" data-mp="1nr6onvtrsz0s">
          <div className="lg:col-span-6" data-id="element-370" data-mp="1ixvnaa7q9ag9">
            <p className="text-[11px] uppercase tracking-widest text-rose" data-id="element-371" data-mp="1xnjrpkb7gp87">{bindweefsel.title}</p>
            <h2 className="mt-5 font-display text-4xl font-light leading-[1.08] sm:text-5xl" data-id="element-372" data-mp="1sphy45g5l7ih">
              {bindweefsel.claim}
            </h2>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-shell/70" data-id="element-373" data-mp="26o7wrpimff8y">
              {bindweefsel.intro}
            </p>
            <Link to="/behandelingen" className="mt-8 inline-flex items-center gap-2 border-b border-shell/40 pb-1 text-sm text-shell transition-colors duration-150 ease-soft hover:border-shell" data-id="element-374" data-mp="caqh0oogjmoh">
              Lees hoe het werkt
              <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-375" data-mp="wttdb0bl8azj" />
            </Link>
          </div>
          <ul className="grid gap-px self-center overflow-hidden bg-shell/15 lg:col-span-6 lg:grid-cols-2" data-id="element-376" data-mp="11rbkal61og4w">
            {bindweefsel.effects.map((e, i) => <li key={e} className="bg-ink p-6" data-id="element-377" data-mp="1alq3uzxlyctt" data-mpi={i}>
                <span className="font-display text-2xl font-light text-rose" data-id="element-378" data-mp="1anavohsjfhnz">0{i + 1}</span>
                <p className="mt-3 text-[14px] leading-snug text-shell/85" data-id="element-379" data-mp="dxabkw345pd0">{e}</p>
              </li>)}
            <li className="bg-ink p-6" data-id="element-380" data-mp="iw508enri851">
              <span className="font-display text-2xl font-light text-rose" data-id="element-381" data-mp="muud864w1no5">3×</span>
              <p className="mt-3 text-[14px] leading-snug text-shell/85" data-id="element-382" data-mp="rvi48rt4a4id">
                Weken tussen elke afspraak in kuurvorm
              </p>
            </li>
          </ul>
        </div>
      </section>

      {/* Philosophy */}
      <section className="border-b border-line bg-shell py-20 lg:py-28" data-id="element-383" data-mp="238ud5h3qhdbe">
        <div className="mx-auto grid max-w-content gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-384" data-mp="2dec063v3ywrn">
          <div className="lg:col-span-5" data-id="element-385" data-mp="28epohyuxhoky">
            <img src={founder.portraitPalm} alt={`${founder.name}, ${founder.role}`} className="arch aspect-[4/5] w-full object-cover" data-id="element-386" data-mp="28fr84rq0fjea" />
          </div>
          <div className="lg:col-span-7 lg:self-center" data-id="element-387" data-mp="1zkl15pf06va6">
            <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-388" data-mp="1uom5dgrciazq">De aanpak</p>
            <blockquote className="mt-5 font-display text-4xl font-light leading-[1.08] text-ink sm:text-[3.25rem]" data-id="element-389" data-mp="1po888tra8lgh">
              “{philosophy.claim}.”
            </blockquote>
            <p className="mt-7 max-w-xl text-[15px] leading-relaxed text-muted" data-id="element-390" data-mp="1go30gii6fl1s">
              {philosophy.body}
            </p>
            <dl className="mt-10 grid gap-8 border-t border-line pt-8 sm:grid-cols-3" data-id="element-391" data-mp="3f2eff8v8geug">
              {[['20+', 'jaar in de huidzorg'], ['100%', 'vegan & dierproefvrij'], ['1 op 1', 'altijd dezelfde specialist']].map(([value, label]) => <div key={label} data-id="element-392" data-mp="8m82zyn1vjl5">
                  <dt className="sr-only" data-id="element-393" data-mp="8p2mnny8p0di">{label}</dt>
                  <dd data-id="element-394" data-mp="mlpwgrbajl0u">
                    <span className="block font-display text-3xl font-light text-clay" data-id="element-395" data-mp="mm95tjmvl139">
                      {value}
                    </span>
                    <span className="mt-1.5 block text-[13px] leading-snug text-muted" data-id="element-396" data-mp="3q3834vfbulzo">
                      {label}
                    </span>
                  </dd>
                </div>)}
            </dl>
            <Link to="/over-ons" className="mt-8 inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-soft hover:text-clay" data-id="element-397" data-mp="3o6kbetjdma7">
              Maak kennis met {founder.firstName}
              <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-398" data-mp="37ax63i7cti9h" />
            </Link>
          </div>
        </div>
      </section>

      {/* Webshop teaser */}
      <section className="bg-sand py-20 lg:py-28" data-id="element-399" data-mp="1hutgqwkk2y7i">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-400" data-mp="1hu1kdjj4wwg6">
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-401" data-mp="1mo5ta8bynejw">
            <div className="lg:col-span-4" data-id="element-402" data-mp="18vpvpn1tw8qd">
              <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-403" data-mp="18x0zvnz6rii0">De webshop</p>
              <h2 className="mt-4 font-display text-4xl font-light leading-[1.08] text-ink" data-id="element-404" data-mp="1cxb3wv3f3yu8">
                Vier merken die het waard zijn
              </h2>
              <p className="mt-5 text-[15px] leading-relaxed text-muted" data-id="element-405" data-mp="25lyw7aml3oha">
                Duurzaam is een product dat zin heeft en doet waarvoor het gemaakt is. Kokos- en
                amandelolie zijn populair, maar doen vaak niets — of het tegenovergestelde.
              </p>
              <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-406" data-mp="g6is49niosy9">
                {brands.map(b => <li key={b.name} className="py-4" data-id="element-407" data-mp="l654yhzfo76j">
                    <p className="font-display text-lg text-ink" data-id="element-408" data-mp="l3itw8dc39jk">{b.name}</p>
                    <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-409" data-mp="2mu9l6sxq42js">{b.description}</p>
                  </li>)}
              </ul>
              <Link to="/webshop" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-410" data-mp="2d4pytdasxqk6">
                Naar de shop
                <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-411" data-mp="24271t9tp685u" />
              </Link>
            </div>

            <div className="lg:col-span-8" data-id="element-412" data-mp="1z7jirqhgq5yn">
              <ul className="grid gap-x-6 gap-y-10 sm:grid-cols-3" data-id="element-413" data-mp="1u75ac7by8u03">
                {shopHighlights.map(p => <li key={p.id} className="h-full" data-id="element-414" data-mp="1q63appe4efxl">
                    <Link to="/webshop" className="group flex h-full flex-col" data-id="element-415" data-mp="3ojv5ese20992">
                      <img src={p.image} alt={`${p.brand} ${p.name}`} className="aspect-[4/5] w-full object-cover transition-opacity duration-200 ease-soft group-hover:opacity-90" data-id="element-416" data-mp="3ohsfe8cwig4c" />
                      <p className="mt-4 text-[11px] uppercase tracking-widest text-clay" data-id="element-417" data-mp="1b80uo3bnynev">
                        {p.brand}
                      </p>
                      <h3 className="mt-1.5 font-display text-lg leading-snug text-ink" data-id="element-418" data-mp="1k2ow1ie4bkye">
                        {p.name}
                      </h3>
                      <p className="mt-2 text-[13px] leading-relaxed text-muted" data-id="element-419" data-mp="ndr0hxyjnj06">{p.note}</p>
                      <p className="mt-auto pt-4 font-display text-lg text-ink" data-id="element-420" data-mp="sb9dq0jlgkdz">€ {p.price}</p>
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Journal + podcast */}
      <section className="border-y border-line bg-shell py-20 lg:py-28" data-id="element-421" data-mp="27qq1ujjwwna4">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-422" data-mp="2cqkuosn8zmxt">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-423" data-mp="2csxj9onigvju">
            <div className="max-w-xl" data-id="element-424" data-mp="2ba7agm99nk4d">
              <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-425" data-mp="26akl5eg5ydf7">Blog &amp; podcast</p>
              <h2 className="mt-4 font-display text-4xl font-light leading-[1.1] text-ink" data-id="element-426" data-mp="2kadjnvxxlxxq">
                Hier deel ik mijn tips en bevindingen
              </h2>
            </div>
            <Link to="/journal" className="text-sm text-ink underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay hover:underline" data-id="element-427" data-mp="2gav136tl1yy2">
              Alles lezen &amp; luisteren
            </Link>
          </div>

          <div className="mt-12 grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-428" data-mp="33x1iukst6t1h">
            <ul className="divide-y divide-line border-y border-line lg:col-span-7" data-id="element-429" data-mp="2yyzxft7wuhmu">
              {articles.slice(0, 3).map(a => <li key={a.slug} data-id="element-430" data-mp="3czkk50gy4xlm">
                  <Link to="/journal" className="group grid gap-4 py-6 sm:grid-cols-12 sm:items-center sm:gap-6" data-id="element-431" data-mp="37zy64otandbr">
                    <div className="sm:col-span-8" data-id="element-432" data-mp="3rjn86rl6sb4i">
                      <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-433" data-mp="foujo4pecxm">
                        {a.category} · {a.readTime}
                      </p>
                      <h3 className="mt-2 font-display text-xl leading-snug text-ink transition-colors duration-150 ease-soft group-hover:text-clay" data-id="element-434" data-mp="3inebhkolfqm2">
                        {a.title}
                      </h3>
                      <p className="mt-2 text-[14px] leading-relaxed text-muted" data-id="element-435" data-mp="3dlovrrqfeorn">{a.excerpt}</p>
                    </div>
                    <p className="text-[12px] text-muted sm:col-span-3 sm:text-right" data-id="element-436" data-mp="2yxu2a94lggdi">{a.date}</p>
                    <ArrowUpRightIcon className="hidden h-4 w-4 text-muted transition-transform duration-200 ease-soft group-hover:-translate-y-0.5 group-hover:text-ink sm:col-span-1 sm:ml-auto sm:block" strokeWidth={1.5} data-id="element-437" data-mp="33vds86anmhla" />
                  </Link>
                </li>)}
            </ul>

            <div className="lg:col-span-5" data-id="element-438" data-mp="10h3aul5l8rrk">
              <div className="bg-sand p-7 lg:p-8" data-id="element-439" data-mp="vnh9hp4vkab2">
                <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-440" data-mp="vmpd4c3ge8jq">
                  Podcast · aflevering {episodes[0].number}
                </p>
                <h3 className="mt-4 font-display text-2xl font-light leading-snug text-ink" data-id="element-441" data-mp="mp5elawz6qct">
                  {episodes[0].title}
                </h3>
                <p className="mt-2 text-[13px] text-muted" data-id="element-442" data-mp="1ef9rkoieob40">{episodes[0].guest}</p>
                <p className="mt-4 text-[14px] leading-relaxed text-muted" data-id="element-443" data-mp="1ed75ugoad453">
                  {episodes[0].summary}
                </p>
                <button type="button" className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-ink px-6 py-3 text-[13px] text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-444" data-mp="15f4vvbmkr15o">
                  <PlayIcon className="h-3 w-3 fill-current" strokeWidth={1.5} data-id="element-445" data-mp="3q6ni565ptb7f" />
                  Luister · {episodes[0].duration}
                </button>
                <ul className="mt-7 divide-y divide-line border-t border-line" data-id="element-446" data-mp="2amo9zrm941pj">
                  {episodes.slice(1).map(e => <li key={e.number} className="py-3 text-[13px] text-muted" data-id="element-447" data-mp="2elx4iyp483m5">
                      <span className="text-ink" data-id="element-448" data-mp="2jeq6xfx42zv2">Afl. {e.number}</span> — {e.title} ·{' '}
                      {e.duration}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-sand py-20 lg:py-28" data-id="element-449" data-mp="2ycim26yqxm8q">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-450" data-mp="32cso58jf3sib">
          <h2 className="sr-only" data-id="element-451" data-mp="32bzsb2lzyney">Wat cliënten zeggen</h2>
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-452" data-mp="13xogum85gbr1">
            <figure className="flex flex-col lg:col-span-7" data-id="element-453" data-mp="13zj07w3rvvt0">
              <span className="font-display text-6xl leading-none text-clay/40" aria-hidden="true" data-id="element-454" data-mp="17z9y0jrpvc71">
                “
              </span>
              <blockquote className="-mt-4 font-display text-3xl font-light leading-[1.22] text-ink sm:text-[2.6rem]" data-id="element-455" data-mp="k3g1ck7prbbw">
                {testimonials[0].quote}
              </blockquote>
              <figcaption className="mt-auto pt-8 text-sm text-muted" data-id="element-456" data-mp="xwxi5x90m9y8">
                {testimonials[0].name} — {testimonials[0].context}
              </figcaption>
            </figure>
            <div className="grid gap-8 lg:col-span-5 lg:content-center" data-id="element-457" data-mp="63x78vbqm0il">
              {testimonials.slice(1).map(t => <figure key={t.name} className="border-l border-line pl-6" data-id="element-458" data-mp="f4btbwwizjn5">
                  <blockquote className="text-[15px] leading-relaxed text-muted" data-id="element-459" data-mp="f5mtlmqri99i">
                    {t.quote}
                  </blockquote>
                  <figcaption className="mt-3 text-[13px] text-ink" data-id="element-460" data-mp="1qiz42gh11q4n">
                    {t.name} — {t.context}
                  </figcaption>
                </figure>)}
            </div>
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="bg-ink py-20 text-shell lg:py-24" data-id="element-461" data-mp="1u3sk7o2uzk7u">
        <div className="mx-auto flex max-w-content flex-col items-start gap-10 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-462" data-mp="1y3swb22hjjbq">
          <div className="max-w-xl" data-id="element-463" data-mp="1p2bk3us781sb">
            <h2 className="font-display text-4xl font-light leading-[1.08]" data-id="element-464" data-mp="1p1jquqm2qg57">
              Boek Beauty Bewust
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-shell/70" data-id="element-465" data-mp="2csfmxzxkbxi9">
              Vragen? Mail naar {salon.email} met je telefoonnummer — {founder.firstName} neemt
              binnen 24 uur contact met je op.
            </p>
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-466" data-mp="280xn5f7a02yv">
            <button type="button" onClick={() => openBooking()} className="rounded-full bg-shell px-7 py-3.5 text-sm text-ink transition-colors duration-150 ease-soft hover:bg-blush" data-id="element-467" data-mp="27zmfh4apmb2h">
              Boek online
            </button>
            <a href={`mailto:${salon.email}`} className="rounded-full border border-shell/30 px-7 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:border-shell" data-id="element-468" data-mp="vyhvx27gg2rk">
              Mail {founder.firstName}
            </a>
          </div>
        </div>
      </section>
    </>;
}